module.exports = __webpack_public_path__ + "static/media/InfinityGreen.df21a762.svg";